import type { ReactNode } from 'react';
import { Container, Input, FormLabel, ErrorMessage } from '../styles';
import type { FieldType } from '../../../types/EvalancheTypes';

export const EmailInput = ({
  field,
  formikProps,
}: {
  field: FieldType;
  formikProps: any;
}): ReactNode => (
  <Container>
    <FormLabel tag="span" type="lead" className="text-gray-500">
      {field.label}
    </FormLabel>
    <Input
      type="email"
      name={field.name}
      onChange={formikProps.handleChange}
      value={formikProps.values[field.name]}
      data-test={`email-${field.name}`}
      autoComplete="email"
      readOnly={field.readonly}
      required={field.required}
    />
    {formikProps.errors[field.name] && (
      <ErrorMessage data-test={`email-${field.name}-error`}>
        {formikProps.errors[field.name]}
      </ErrorMessage>
    )}
  </Container>
);
